module.exports = __webpack_public_path__ + "img/ch13_08_星域之梦.6339a64b.jpg";